import ReportContent from './Content'
import ReportDialog from './ReportDialog'
const components = {
  ReportContent,
  ReportDialog
}

export default function install (Vue) {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
  })
}



// WEBPACK FOOTER //
// ./src/views/report/modules/index.js